import Phaser from 'phaser'
import { Background } from '../base/background'
import { RED_BALL_ATLAS_FRAMES, RED_BALL_TEXTURE_KEYS } from './constants'

export class RedBallBackground extends Background {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y)
  }

  createBackground() {
    const background = this.scene.add.image(
      0,
      10,
      RED_BALL_TEXTURE_KEYS.ATLAS,
      RED_BALL_ATLAS_FRAMES.GRID_BACKGROUND,
    )
    background.setOrigin(0.5, 0.5)

    background.scale = 1.03

    this.add([background])
  }
}
